
import React from "react";

import * as firebaseui from 'firebaseui/dist/npm__pt_br'
import 'firebaseui/dist/firebaseui.css'
import { GoogleAuthProvider, FacebookAuthProvider, EmailAuthProvider } from "firebase/auth";


const providerGoogle = new GoogleAuthProvider();
const providerFace = new FacebookAuthProvider();
const providerEmail = new EmailAuthProvider();

// FirebaseUI config.
const uiConfig = {
  callbacks: {
    signInSuccessWithAuthResult: function (authResult, redirectUrl) {

      return true;

    }
  },
  // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
  signInFlow: 'popup',
  signInSuccessUrl: './',
  signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
    providerGoogle.providerId, providerFace.providerId, providerEmail.providerId
  ],
  // tosUrl and privacyPolicyUrl accept either url string or a callback
  // function.
  tosUrl: '<your-tos-url>',
  // Privacy policy url.
  privacyPolicyUrl: '<your-privacy-policy-url>'
};



export default class SignInScreen extends React.Component {

  constructor(props) {
    super(props)
  }


  componentDidMount() {
    if (firebaseui.auth.AuthUI.getInstance()) {
      const ui = firebaseui.auth.AuthUI.getInstance()
      ui.start('#firebaseui-auth-container', uiConfig)
    } else {
      const ui = new firebaseui.auth.AuthUI(this.props.auth.auth);
      ui.start('#firebaseui-auth-container', uiConfig)
    }

  }
  render() {
    return (
      <div>
        <div id="firebaseui-auth-container"></div>
      </div>
    );
  }
}